<template>
    <div>
		<el-form ref="queryForm" class="query-box" v-model="queryParams" label-width="68px">
			<el-row :gutter="20">
				<el-col :span="6">
					<el-form-item label="员工编号" prop="userId">
						<el-input v-model="queryParams.userId"
								  :placeholder="translate('FROM.PLACEHOLDER', {param: 'USER.USER_ID'})" clearable
								  size="small" @keyup.enter.native="handleQuery"/>
					</el-form-item>
				</el-col>
				<el-col :span="6">
					<el-form-item label="员工昵称" prop="nickname">
						<el-input v-model="queryParams.nickname"
								  :placeholder="translate('FROM.PLACEHOLDER', {param: 'USER.NICKNAME'})" clearable
								  size="small" @keyup.enter.native="handleQuery"/>
					</el-form-item>
				</el-col>
				<el-col :span="6">
					<el-form-item label="员工名称" prop="loginName">
						<el-input v-model="queryParams.loginName"
								  :placeholder="translate('FROM.PLACEHOLDER', {param: 'USER.LOGIN_NAME'})" clearable
								  size="small" @keyup.enter.native="handleQuery"/>
					</el-form-item>
				</el-col>
				<el-col :span="6">
					<el-form-item label="员工手机号" prop="phone" label-width="82px">
						<el-input v-model="queryParams.phone"
								  :placeholder="translate('FROM.PLACEHOLDER', {param: 'USER.PHONE'})" clearable
								  size="small" @keyup.enter.native="handleQuery"/>
					</el-form-item>
				</el-col>
			</el-row>
			<el-row :gutter="20">
				<el-col :span="6">
					<el-form-item label="员工状态" prop="status">
						<el-select v-model="queryParams.status"
								   :placeholder="translate('COMMON.STATUS')" clearable size="small" style="width: 100%">
							<el-option v-for="(value,key) in dicts.STATUS" :key="key" :label="value" :value="value"/>
						</el-select>
					</el-form-item>
				</el-col>
			</el-row>	
		</el-form>

		<el-row :gutter="10" class="mb8">
			<el-col :span="1.5">
				<el-button type="primary" icon="el-icon-search" size="mini" @click="handleQuery">{{translate('OPERATION.QUERY')}}</el-button>
				<el-button icon="el-icon-refresh" size="mini" @click="handleResetQuery">{{translate('OPERATION.RESET')}}</el-button>
				<el-button type="primary" icon="el-icon-plus" size="mini" @click="handleAdd" v-permission="'SYS_USER_INSERT'">{{translate('OPERATION.ADD')}}</el-button>
				<el-button type="warning" icon="el-icon-download" size="mini" @click="handleExport" v-permission="'SYS_USER_EXPORT'">{{translate('OPERATION.EXPORT')}}</el-button>
			</el-col>
		</el-row>

		<CustomForm :dicts="dicts" :on-fresh="showCustomForm" @on-close="handlerCustomFormOnclose" :isAdd="true"></CustomForm>
	</div>
</template>

<script>
	import CustomForm from "./CustomForm";
	import {UserApi} from '@/api';
    export default {
        name: "ToolBar",
		components: {CustomForm},
		props: {
			dicts: {
				type: Object,
				default: {}
			}
		},
		data() {
			return {
				queryParams: {},
				createDateRange: [],
				updateDateRange: [],
				showCustomForm: false,
			}
		},
		mounted() {
		},
		methods: {
			handlerCustomFormOnclose() {
				this.showCustomForm = false;
				this.commitChange();
			},
			handleQuery() {
				this.commitChange();
			},
			handleResetQuery(){
				this.queryParams = {};
				this.createDateRange = [];
				this.updateDateRange = [];
				this.commitChange();
			},
			handleAdd(){
				this.showCustomForm = true;
			},
			handleExport() {
				this.$confirm(this.translate('FROM.CONFIRM_EXPORT', {module: 'MODULE.USER'}), this.translate('FROM.WARNING'), {
					confirmButtonText: this.translate('FROM.SUBMIT'),
					cancelButtonText: this.translate('FROM.CANCEL'),
					type: "warning"
				}).then(async () => {
					this.dealWithQueryParams();
					let result = (await UserApi.user.export(this.queryParams));
					if (result.success) {
						this.downloadFile(result.data);
					}
				});
			},
			dealWithQueryParams() {
				let [startCreateTime, endCreateTime] = this.createDateRange;
				this.queryParams.startCreateTime = startCreateTime && (startCreateTime + ' 00:00:00');
				this.queryParams.endCreateTime = endCreateTime && (endCreateTime + ' 23:59:59');

				let [startUpdateTime, endUpdateTime] = this.updateDateRange;
				this.queryParams.startUpdateTime = startUpdateTime && (startUpdateTime + ' 00:00:00');
				this.queryParams.endUpdateTime = endUpdateTime && (endUpdateTime + ' 23:59:59');
			},
			commitChange() {
				this.dealWithQueryParams();
				let params = {...this.queryParams};
				this.$emit('on-change', params);
			},
		}
    }
</script>

<style scoped>

</style>
